export const getUrlCompanyAPI = url => {
    return 'https://truyxuatnguongoc.tiengiang.gov.vn:9803/api/' + url;
};